type IdleCallbackHandle = ReturnType<typeof setTimeout>;

type IdleDeadline = {
  didTimeout: boolean;
  timeRemaining: () => number;
};

type IdleCallback = (deadline: IdleDeadline) => void;

const hasWindow = typeof window !== 'undefined';
const requestIdle: (callback: IdleCallback) => IdleCallbackHandle =
  hasWindow && typeof window.requestIdleCallback === 'function'
    ? window.requestIdleCallback.bind(window)
    : (callback: IdleCallback): IdleCallbackHandle => {
        return setTimeout(() => {
          callback({
            didTimeout: false,
            timeRemaining: () => 0
          });
        }, 16);
      };

export const runWithIdlePriority = async <T>(task: () => Promise<T> | T): Promise<T> => {
  return new Promise<T>((resolve, reject) => {
    try {
      requestIdle(async () => {
        try {
          const result = await task();
          resolve(result);
        } catch (error) {
          reject(error);
        }
      });
    } catch (error) {
      reject(error);
    }
  });
};

